import Model from './BaseModel';
import MarketType from './MarketType';

export default class MultiGroup extends Model {
	resourceName() {
		return 'multi_exclusion_groups';
	}

	fields() {
		return ['name', 'sport'];
	}

	relationships() {
		return {
			excluded_market_types: new MarketType()
		};
	}

	getBySportId(sportId) {
		this.queryBuilder.include('excluded_market_types');
		return this.makePersistRequest({
			url: `${this.baseUrl()}/sports/${sportId}/${this.resourceName()}${this.queryBuilder.getQuery()}`,
			method: 'GET'
		}).catch(() => {});
	}

	preparePayload(overrideData = {}) {
		return Object.assign(
			{},
			{
				name: this.name,
				sport_id: this.sport.id,
				excluded_market_types: this.excluded_market_types.data.pluck('id').all()
			},
			overrideData
		);
	}
}
